/**
 * Created by liwenqiang on 2018/3/20.
 */
require('../global/global')
require('./detail/index.scss')
require('../global/base/layout.scss')
require('../global/css/crumbs.scss')
require('./detail/share/css/share.min.scss')
const Cookies = require('js-cookie')

const $ = require('jquery')
require('../global/js/content-min-height')()
require('../global/js/toTop')
require('./../global/js/jquery.share.min.js')

const ShareConfig = {
  // url: 'http://www.toodc.cn/baike/detail/23', // 网址，默认使用 window.location.href
  // source              : '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
  // title               : '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
  // description         : '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
  // image               : '', // 图片, 默认取网页中第一个img标签
  sites: ['wechat', 'weibo', 'qzone', 'qq'], // 启用的站点
  disabled: ['google', 'facebook', 'twitter', 'douban'], // 禁用的站点
  wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
  wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>',
}
var showImgBig = {
  init: function() {
    var that = this,
      small_con = $('.detail-content-article'),
      small_img = small_con.find('img')

    small_img.on('click', function() {
      var src = $(this).attr('src')
      that.showImg(src)
    })
  },
  showImg: function(src) {
    var imgMark = $('.big-img-mask') //外层蒙版
    var pic = imgMark.find('.pic')
    var img = pic.find('img')
    var W = $(window).width() //窗口宽度
    var H = $(window).height() //窗口高度
    var showImgW = 850 //图片显示最大宽度
    var showImgH = 635 //图片显示最大高度

    imgMark.show()
    img.attr('src', src)
    var imgScale = img.width() / img.height() //图片高宽比，>=1图片以宽度进行缩放,<1以高度进行缩放
    if (imgScale >= 1) {
      var imgShowH = img.height() / (img.width() / showImgW) //图片以宽度缩放后的实际显示高度
      if (H - imgShowH < 50) {
        //实际显示高度大于窗口高度重新以高度缩放
        pic
          .css({ width: 'auto', height: showImgH })
          .addClass('picH')
          .removeClass('picW')
      } else {
        pic
          .css({ width: showImgW, height: 'auto' })
          .addClass('picW')
          .removeClass('picH')
      }
    } else {
      pic
        .css({ width: 'auto', height: showImgH })
        .addClass('picH')
        .removeClass('picW')
    }

    img.addClass('scale')

    imgMark.on('click', function() {
      imgMark.hide()
      img.removeClass('scale')
    })
    img.on('click', function(e) {
      e.stopPropagation()
    })
  },
}
showImgBig.init()
$('.social-share').share(ShareConfig)

// 验证是否登录
//     -> 已登录 -> 验证是否绑定邮箱
//         -> 已绑定 直接发送报告 success-wrapper
//         -> 未绑定 要求绑定邮箱 email-wrapper
//     -> 未登录 要求登录 login-wrapper

let email = ''
let accountId = ''
const getAccountInfo = () => {
  const auth_token = Cookies.get('auth_token')
  if (!auth_token) {
    $('.login-wrapper').show()
    return
  }

  $.ajax({
    type: 'GET',
    url: '/account/info',
  }).then(function(data) {
    if (data.code !== '0' || !data.data) {
      $('.login-wrapper').show()
      return
    }

    email = data.data.email
    accountId = data.data.accountId
    $('.login-wrapper').hide()
    $('.email-wrapper').show()
    $('.email-wrapper .phone input').val(email)
  })
}

$('#J_download').click(function(e) {
  getAccountInfo()
  window.ga('send', 'event', 'baike-report', 'click', 'download-btn')
})

$('.login-wrapper .commit').click(function(e) {
  window.ga('send', 'event', 'baike-report', 'click', 'login-btn')

  const phone = $('.login-wrapper .phone input')
    .val()
    .trim()
  const code = $('.login-wrapper .code input')
    .val()
    .trim()

  if (!phone || !code) return

  $.ajax({
    type: 'post',
    url: '/auth/login',
    data: {
      mobile: phone,
      password: code,
      zcode: '',
      type: 'login',
    },
    success: function(response) {
      if (response.code === '0') {
        getAccountInfo()
      } else {
        alert(response.msg)
      }
    },
  })
})

$('#getCode').click(function(e) {
  window.ga('send', 'event', 'baike-report', 'click', 'code-btn')

  const phone = $('.login-wrapper .phone input')
    .val()
    .trim()
  if (!phone) return

  $.ajax({
    type: 'post',
    url: '/auth/sms',
    data: { mobile: phone },
    success: function(response) {
      if (response.code === '0') {
        let seconds = 60

        $('#getCode').html(`重新发送(${seconds}s)`)
        let times = setInterval(_ => {
          if (--seconds > 0) {
            $('#getCode').html(`重新发送(${seconds}s)`)
            return
          }
          clearInterval(times)
          $('#getCode').html('获取验证码')
        }, 1000)
      } else {
        alert(response.msg)
      }
    },
  })
})

$('.email-wrapper .commit').click(function(e) {
  window.ga('send', 'event', 'baike-report', 'click', 'email-btn')

  const id = $('#J_detail').data('id')
  const myEmail = $('.email-wrapper .phone input').val()
  const emailRegExp = /^[a-zA-Z0-9\._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/

  if (!emailRegExp.test(myEmail)) {
    alert('请输入正确的邮箱地址')
    return
  }

  $.ajax({
    type: 'post',
    url: '/account/save',
    data: {
      data: JSON.stringify({
        accountId: accountId,
        email: myEmail,
      }),
    },
    success: function() {
      $.ajax({
        type: 'get',
        url: '/reportDownload',
        data: { id, accountId },
        success: function(response) {
          if (response.code === '0') {
            $('.email-wrapper').hide()
            $('.success-wrapper').show()
            $('.success-wrapper .email').html(myEmail)
          } else {
            alert(response.msg)
          }
        },
      })
    },
  })
})

$('.dialog-wrapper .close').click(function(e) {
  window.ga('send', 'event', 'baike-report', 'click', 'close-dialog')
  $('.dialog-wrapper').hide()
})

$('.success-wrapper .close-btn').click(function(e) {
  $('.dialog-wrapper').hide()
})



//////////////////
// WEBPACK FOOTER
// ./src/project/detail.page.js
// module id = 44
// module chunks = 0